import Authorized from './authorized';

export default Authorized;
